import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const postAdvertRoute: RouteConfig<'with-page'> = {
    name: 'Post Advert',
    path: '/adverts/post-advert',
    page: lazy(() => import('.')),
    context: 'member',
    roles: ['ncassMember', 'accountManager'],
}
